export default __webpack_public_path__ + "static/media/bar-fuel-consumption.c2323916.svg";